import { Injectable } from '@angular/core';
import { BehaviorSubject,ReplaySubject } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class GlobalService {

  public SelectedPage = '';
  public SelectedTaskTab = 'Pending';
  public ShowTaskCard = false;
  public DisplayWaitControl = true;
  public pendingRequests = 0;
  private _userToken: string;
  public _loopCount:number=0;

  get UserToken(): string {
    if (this._userToken === null || this._userToken === undefined) {
      if (localStorage.getItem('_userToken') !== '' && localStorage.getItem('_userToken') !== null)
        return 'Token ' + localStorage.getItem('_userToken');
      else {
        return null;
      }
    }
    return 'Token ' + this._userToken;
  }

  set UserToken(value: string) {

    this._userToken = value;
    localStorage.removeItem('_userToken');
    localStorage.setItem('_userToken', this._userToken);
  }


  public loadingProgramData = new BehaviorSubject<boolean>(false);
  public loadingTaskData = new BehaviorSubject<boolean>(false);

  // Observable string for loader/loading screen
  public loading = new BehaviorSubject<boolean>(false);

  // Observable string source
  private selected_card = new ReplaySubject<string>();

  // Observable string stream
  selectedCard$ = this.selected_card.asObservable();

  constructor() {
  }
  // Service message commands
  public SetSelectedCard(data: string): void {
    this.selected_card.next(data)
  }

  public setLoadingOn(): void {
    this.loading.next(true);
  }

  public setLoadingOff(): void {
    this.loading.next(false);
  }

  public checkLoading(): void {
    if (!this.loadingProgramData.value && !this.loadingTaskData.value) {
      this.loading.next(false);
    }
  }
  increaseLoopCount(): void {
    if (localStorage.getItem('_loopCount') !== null && localStorage.getItem('_loopCount') !== '') {
      this._loopCount = parseInt(localStorage.getItem('_loopCount'), 10);
    }
    this._loopCount = this._loopCount + 1;
    localStorage.setItem('_loopCount', this._loopCount.toString());
  }
  getLoopCount(): number {
    if (localStorage.getItem('_loopCount') !== null && localStorage.getItem('_loopCount') !== '') {
      this._loopCount = parseInt(localStorage.getItem('_loopCount'), 10);
    } else {
      this._loopCount = 0;
    }
    return this._loopCount;
  } 
  resetLoopCount(): void {
    this._loopCount = 0;
     localStorage.setItem('_loopCount', this._loopCount.toString());
  }
}
